/**
 * Transcript file helpers.
 *
 * Tracked changes are NOT derived here. A deletion is a mark carried by the
 * document itself (see utils/transcriptDoc.ts), stored in Supabase alongside
 * the readable text, so nothing is ever reconstructed by comparing one saved
 * string against another.
 */

/** Downloads the transcript as a plain text file, named after the deliverable. */
export function downloadTranscript(name: string, text: string): void {
  if (typeof window === 'undefined') return
  const blob = new Blob([text], { type: 'text/plain;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `${name.replace(/[^\w\s-]/g, '').trim() || 'Transcript'}.txt`
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
